import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { AdminViewComponent } from "./admin-view.component";
import { ApiService } from "src/app/services";
import { ModalService } from "src/app/shared/modal.service";
import { AZConfigColumnDefinitionForAdmin } from "./ag-grid-column-definition";
import { DataTypes } from "./admin-view-data-types";
import { AZConfig } from "../../generated-models";
import { SharedDataService } from "../../services/sharedDataService";

@Component({
  standalone: false,
  selector: "admin-view/azconfig",
  templateUrl: "./admin-view.component.html",
  styleUrls: ["../../styles.scss"],
})
export class AdminViewAZConfigComponent extends AdminViewComponent<AZConfig> implements OnInit {
  type = "AZ Config";
  tableName = "AZ Config";
  columnDef = AZConfigColumnDefinitionForAdmin;
  keyFilterStats = "filter:admin-view-azconfig";

  constructor(
    apiService: ApiService,
    modalService: ModalService,
    notificationService: ToastrService,
    sharedDataService: SharedDataService,
    dataTypes: DataTypes
  ) {
    super(apiService, modalService, notificationService, sharedDataService, dataTypes);
    this.addRowEnable = true;
    this.addRowFunc = (data: AZConfig) => apiService.setAZConfig(data).toPromise();
    this.getDefaultValueFunc = () => ({ IsEnabled: true });
    this.updateRowFunc = (data: AZConfig) => apiService.setAZConfig(data).toPromise();
  }

  refreshData() {
    super.refreshData();
    this.apiService.getAZConfig().subscribe((response) => {
      this.setRowData(response);
      super.setupFilterByLocalData();
    });
  }
}
